import React, { FC, ReactNode } from 'react';
import SubmitButton from '../buttons/Submit/SubmitButton';

import { Form as AntForm } from 'antd';

type Props = {
  children: ReactNode;
  handleSubmit?: any;
  buttonLabel: string;
  loading?: boolean;
  gridSize?: string;
  buttonStyle?: string;
  disable?: boolean;
};

const Form: FC<Props> = ({
  children,
  handleSubmit,
  buttonLabel,
  loading,
  gridSize,
  buttonStyle = 'default',
  disable,
}) => {
  return (
    <AntForm className="flex-initial" onFinish={handleSubmit}>
      {loading}
      <div className="mb-3 ">
        {children}
        <SubmitButton
          text={buttonLabel}
          loading={loading}
          style={buttonStyle}
          disabled={disable}
        />
      </div>
    </AntForm>
  );
};

export default Form;
